/**
 * Note: these are now referred to as 'consultation groups' in the user interface,
 * but leaving them as referrals in the code base (don't want to break things and could change again)
 * TODO: ultimately refactor in DV server and only client referral groups sent on Page Note to use this object ... thanks ...
 */

var GroupCollection = require('./groupCollection'),
    fvChannel = require('glRadio').channel('FV');


module.exports = GroupCollection.extend({

    url: function() {
        return fvChannel.request('apiUrl').referralGroups;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/referralGroups.js
 ** module id = 89
 ** module chunks = 0
 **/